export default theme => ({
  dialogPaper: {
    overflow: 'initial',
    backgroundColor: theme.palette.grey.light,
    color: theme.palette.grey.contrastText,
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(4),
    },
    '& > *': {
      position: 'relative',
    },
  },
  dialogContent: {
    padding: 0,
  },
  closeIcon: {
    zIndex: 5,
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(50%,-50%)',
    [theme.breakpoints.down('sm')]: {
      height: 40,
      width: 40,
      '& svg': {
        height: 25,
        width: 25,
      },
    },
    [theme.breakpoints.down('xs')]: {
      height: 32,
      width: 32,
      minHeight: 32,
      right: theme.spacing(4),
      '& svg': {
        height: 20,
        width: 20,
      },
    },
  },
});
